import {
  apiClient,
  type PageEntity,
  type SiteImportJobExEntity
} from '@/libs/api'
import { type SiteImportJobsRequestQuery } from '@/libs/api/types'

export type FetchSiteImportJobsQuery = {
  tenantKey: string
  query: SiteImportJobsRequestQuery
}

export type FetchSiteImportJobsResponse = {
  data: SiteImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchSiteImportJobs = async (
  { tenantKey, query }: FetchSiteImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchSiteImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .site_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
